var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoImageExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A4A9C8",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 18v-1.52l3.93-3.14 2.36 2.37c.366.367.953.394 1.35.06l5.3-4.42L18 14.41V18H2zM18 2v9.59l-2.29-2.3c-.366-.367-.952-.393-1.35-.06l-5.3 4.42-2.35-2.36c-.361-.358-.933-.388-1.33-.07L2 13.92V2h16zm1-2H1C.448 0 0 .448 0 1v18c0 .553.448 1 1 1h18c.553 0 1-.447 1-1V1c0-.552-.447-1-1-1z",
    transform: "translate(6 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1m0 4c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3",
    transform: "translate(6 7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImageExperiment);
export default __webpack_public_path__ + "static/media/ico-image-experiment.bfd75f303a439b5de1014c6e9f878842.svg";
export { ForwardRef as ReactComponent };